module.exports = __webpack_public_path__ + "static/media/team-5@3x.3acb6849.jpg";